import React from "react";
import { useLocation } from "react-router-dom";
// import components
import BreadcrumbHead from "../../../../Components/BreadcrumbHead/BreadcrumbHead";
import Footer from "../../../../Components/Footer/Footer";
import Navbar from "../../../../Components/Navbar/Navbar";
import Introduction from "../Components/Introduction";

const descriptions = [
  "Featuring Cross Culture Asia (CCA), the pioneering global association for overseas Asian women. Our collaboration with CCA has fostered a vibrant platform that connects members worldwide, promoting unity and cultural heritage. Together, we have developed tools to enhance member engagement, support unique businesses within the community, and organize culturally rich meet-ups. CCA's mission to uphold equality and togetherness is now more accessible and impactful, thanks to our partnership.  ",
];
const linkText =
  "Check CCA in celebrating diversity and strengthening bonds across the globe.";

function CCAProjectDetail() {
  const location = useLocation();
  const { state: project } = location;
  return (
    <>
      <Navbar />
      <BreadcrumbHead title={"Cross Culture Asia (CCA)"} />
      <Introduction
        src={project.imagePath}
        linkText={linkText}
        linkUrl={project.linkUrl}
        appStoreUrl={project.appStoreUrl}
        googlePlayUrl={project.googlePlayUrl}
        descriptions={descriptions}
      />
      <Footer />
    </>
  );
}

export default CCAProjectDetail;
